import { render, staticRenderFns } from "./ScreeningAdviceStatusItem.vue?vue&type=template&id=6299f2fe&scoped=true&"
import script from "./ScreeningAdviceStatusItem.vue?vue&type=script&lang=js&"
export * from "./ScreeningAdviceStatusItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningAdviceStatusItem.vue?vue&type=style&index=0&id=6299f2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6299f2fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
